// @flow
const START_SESSION = 'studyset:start-session';
const SESSION_LOADED = 'studyset:loaded';
const SESSION_ERROR = 'studyset:error';
const RESET_SESSION_CREATED = 'studyset:reset';
const LOAD_DATA_SESSION = 'studyset:loadData';
const SET_PROGRESS_BAR = 'studySet:progressBar';
const SET_ANSWEREVENT_STATUS = 'set:AnswerEvent';
export {
  START_SESSION,
  SESSION_LOADED,
  SESSION_ERROR,
  RESET_SESSION_CREATED,
  LOAD_DATA_SESSION,
  SET_PROGRESS_BAR,
  SET_ANSWEREVENT_STATUS,
};
